export class FatcaDetailsModel{

    public OutsidePakCheck:string;
    public CountryNames:string;
    public Nationalities:string;
    public BirthCountry:string;
    public TIN:string;
    public USCitizenReason:string;
    public USLost:string;
    public CustomerFatcaDetailId:number;
    public CreatedBy:string;
    constructor(){
        
    }
}